module.exports = __webpack_public_path__ + "img/gptw.5720e3b7.jpg";